module.exports = "<div id=tooltip class=overlay> <div id=tooltip-text class=\"label label-default\"> Hometown </div> </div> ";